
export enum PlanType {
    BASIC = 'basic',
    SPONSOR = 'sponsor',
    HIRING_PLUS = 'hiring_plus'
}
